export default __webpack_public_path__ + "static/media/projimg_Jola_crop.45d8d790.png";